import { createStore } from '@/v2/stores/flowNavigation.storeFactory';

export const usePayFlowNavigationStore = createStore({
  name: 'pay-flow-navigation',
  flow: 'pay',
  persist: true,
});
